// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-container {
  position: relative;
  display: inline-block;
  transition: all 0.3s ease;
}

.tooltip {
  position: fixed;
  z-index: 1000;
  max-width: 320px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  /* padding: 5px 10px; */
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
  box-shadow: 0 20px 60px rgba(102, 126, 234, 0.4), 0 8px 24px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(20px);
  pointer-events: none;
  text-align: center;
  letter-spacing: 0.3px;
}

.tooltip-content {
  position: relative;
  z-index: 2;
}

.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
}

/* Позиционирование стрелки для разных позиций */
.tooltip-top .tooltip-arrow {
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  border-top-color: #667eea;
}

.tooltip-bottom .tooltip-arrow {
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  border-bottom-color: #667eea;
}

.tooltip-left .tooltip-arrow {
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  border-left-color: #667eea;
}

.tooltip-right .tooltip-arrow {
  left: -8px;
  top: 50%;
  transform: translateY(-50%);
  border-right-color: #667eea;
}

/* Анимации появления/исчезновения */
.tooltip-enter {
  animation: tooltipFadeIn 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: scale(0.8) translateY(15px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.tooltip-exit {
  animation: tooltipFadeOut 0.4s cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

@keyframes tooltipFadeOut {
  from {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  to {
    opacity: 0;
    transform: scale(0.8) translateY(15px);
  }
}

/* Дополнительные эффекты */
.tooltip::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  border-radius: 16px;
  pointer-events: none;
}

/* Улучшенное позиционирование для лучшей видимости */
.tooltip-top {
  margin-bottom: 8px;
}

.tooltip-content {
  position: relative;
  z-index: 2;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .tooltip {
    max-width: 280px;
    font-size: 13px;
    padding: 14px 18px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/parser/Tooltip.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,6DAA6D;EAC7D,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,+EAA+E;EAC/E,0CAA0C;EAC1C,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,6BAA6B;EAC7B,iDAAiD;AACnD;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,kEAAkE;AACpE;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,sCAAsC;EACxC;AACF;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gGAAgG;EAChG,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yCAAyC;AAC3C;;AAEA,yCAAyC;AACzC;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".tooltip-container {\r\n  position: relative;\r\n  display: inline-block;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.tooltip {\r\n  position: fixed;\r\n  z-index: 1000;\r\n  max-width: 320px;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  /* padding: 5px 10px; */\r\n  border-radius: 16px;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  font-weight: 400;\r\n  box-shadow: 0 20px 60px rgba(102, 126, 234, 0.4), 0 8px 24px rgba(0, 0, 0, 0.2);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  backdrop-filter: blur(20px);\r\n  pointer-events: none;\r\n  text-align: center;\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n.tooltip-content {\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.tooltip-arrow {\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n  border: 8px solid transparent;\r\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));\r\n}\r\n\r\n/* Позиционирование стрелки для разных позиций */\r\n.tooltip-top .tooltip-arrow {\r\n  bottom: -12px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  border-top-color: #667eea;\r\n}\r\n\r\n.tooltip-bottom .tooltip-arrow {\r\n  top: -8px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  border-bottom-color: #667eea;\r\n}\r\n\r\n.tooltip-left .tooltip-arrow {\r\n  right: -8px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  border-left-color: #667eea;\r\n}\r\n\r\n.tooltip-right .tooltip-arrow {\r\n  left: -8px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  border-right-color: #667eea;\r\n}\r\n\r\n/* Анимации появления/исчезновения */\r\n.tooltip-enter {\r\n  animation: tooltipFadeIn 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n\r\n@keyframes tooltipFadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.8) translateY(15px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1) translateY(0);\r\n  }\r\n}\r\n\r\n.tooltip-exit {\r\n  animation: tooltipFadeOut 0.4s cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n}\r\n\r\n@keyframes tooltipFadeOut {\r\n  from {\r\n    opacity: 1;\r\n    transform: scale(1) translateY(0);\r\n  }\r\n  to {\r\n    opacity: 0;\r\n    transform: scale(0.8) translateY(15px);\r\n  }\r\n}\r\n\r\n/* Дополнительные эффекты */\r\n.tooltip::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);\r\n  border-radius: 16px;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Улучшенное позиционирование для лучшей видимости */\r\n.tooltip-top {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.tooltip-content {\r\n  position: relative;\r\n  z-index: 2;\r\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* Адаптивность для мобильных устройств */\r\n@media (max-width: 768px) {\r\n  .tooltip {\r\n    max-width: 280px;\r\n    font-size: 13px;\r\n    padding: 14px 18px;\r\n  }\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
